import VisitsExport from "./visits-export";

export default VisitsExport;